import type { ChatUiHotelOffer } from './hotel_planner_schema.js';

/** Puts the selected offer first, then caps the list — the dock only shows a
 *  handful of cards. */
export function deckOffersFor<T extends Pick<ChatUiHotelOffer, 'offerId'>>(
  offers: T[],
  selectedOfferId?: string,
  limit = 4,
): T[] {
  const selected = offers.find((offer) => offer.offerId === selectedOfferId);
  const rest = offers.filter((offer) => offer.offerId !== selectedOfferId);
  return (selected ? [selected, ...rest] : offers).slice(0, limit);
}
